import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";
import BackButton from "../../components/BackButton";

import Odpadykomunalne from "../../content/przyjaznedeklaracje/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx";

export default function OplataZaGospodarowanieOdpadamiKomunalnymi(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "odpadykomunalne";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx maxWidth>
				<Odpadykomunalne />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox center>
					<DeclarationBoxItem miasto={Miasto} podatek={Podatek} noReadMore />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} podatek={Podatek} />
			</Section>

			<Section>
				<BackButton />
			</Section>
		</SectionLayout>
	);
}
